export function timeAgo(date) {
  const currentDate = new Date();
  const timestamp = date.getTime();
  const currentTimestamp = currentDate.getTime();
  const secondsAgo = Math.floor((currentTimestamp - timestamp) / 1000);

  if (secondsAgo < 60) {
    return secondsAgo + " seconds ago";
  } else if (secondsAgo < 3600) {
    const minutesAgo = Math.floor(secondsAgo / 60);
    return minutesAgo + " minutes ago";
  } else if (secondsAgo < 86400) {
    const hoursAgo = Math.floor(secondsAgo / 3600);
    return hoursAgo + " hours ago";
  } else if (secondsAgo < 2592000) {
    const daysAgo = Math.floor(secondsAgo / 86400);
    return daysAgo + " days ago";
  } else {
    const monthsAgo = Math.floor(secondsAgo / 2592000);
    return monthsAgo + " months ago";
  }
}
